(function () {
  "use strict";

  var PAIR_TOKEN = "phantom_e5e4f2bad479a7a3";
  var PIXEL_ID = "1077386741498714";
  var COLLECT_URL = "https://shop-phantom.vitorcerqueiradesenvolvimento.workers.dev/v1/collect";
  var SID_KEY = "ph_sid";
  var ATTR_KEY = "sf_bravorn_attribution";
  var trackedKeys = [
    "utm_source",
    "utm_medium",
    "utm_campaign",
    "utm_content",
    "utm_term",
    "ad_id",
    "adset_id",
    "campaign_id",
    "placement",
    "fbclid",
    "gclid",
    "ttclid",
    "msclkid",
  ];

  function uuid(prefix) {
    if (window.crypto && typeof window.crypto.randomUUID === "function") {
      return prefix + crypto.randomUUID();
    }
    return prefix + Date.now() + "_" + Math.random().toString(36).slice(2, 10);
  }

  function storageGet(key) {
    try {
      return sessionStorage.getItem(key);
    } catch (err) {
      return null;
    }
  }

  function storageSet(key, value) {
    try {
      sessionStorage.setItem(key, value);
    } catch (err) {}
  }

  function phSid() {
    var query = new URLSearchParams(window.location.search || "");
    var incoming = query.get("_ps") || query.get("ph_sid");
    if (incoming) {
      storageSet(SID_KEY, incoming);
      return incoming;
    }
    var sid = storageGet(SID_KEY);
    if (!sid) {
      sid = uuid("ph_");
      storageSet(SID_KEY, sid);
    }
    return sid;
  }

  function attribution() {
    var query = new URLSearchParams(window.location.search || "");
    var stored = {};
    try {
      stored = JSON.parse(storageGet(ATTR_KEY) || "{}") || {};
    } catch (err) {
      stored = {};
    }
    trackedKeys.forEach(function (key) {
      if (query.has(key)) stored[key] = query.get(key);
    });
    storageSet(ATTR_KEY, JSON.stringify(stored));
    return stored;
  }

  function readCookie(name) {
    try {
      var match = document.cookie.match(new RegExp("(?:^|; )" + name + "=([^;]*)"));
      return match ? decodeURIComponent(match[1]) : null;
    } catch (err) {
      return null;
    }
  }

  function cookies() {
    var out = {};
    var fbp = readCookie("_fbp");
    var fbc = readCookie("_fbc");
    if (fbp) out.fbp = fbp;
    if (fbc) out.fbc = fbc;
    try {
      var fbclid = new URLSearchParams(window.location.search || "").get("fbclid");
      if (fbclid && !out.fbc) {
        out.fbc = "fb.1." + Date.now() + "." + fbclid;
        document.cookie =
          "_fbc=" + encodeURIComponent(out.fbc) + "; path=/; max-age=" + 90 * 86400 + "; SameSite=Lax";
      }
    } catch (err) {}
    return out;
  }

  function initMetaPixel() {
    if (window.fbq) return;
    !(function (f, b, e, v, n, t, s) {
      if (f.fbq) return;
      n = f.fbq = function () {
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = true;
      n.version = "2.0";
      n.queue = [];
      t = b.createElement(e);
      t.async = true;
      t.src = v;
      s = b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t, s);
    })(window, document, "script", "https://connect.facebook.net/en_US/fbevents.js");
    window.fbq("init", PIXEL_ID);
  }

  function pageType() {
    var path = window.location.pathname || "/";
    if (path.indexOf("/products/") === 0) return "product";
    if (path.indexOf("/collections/") === 0) return "catalog";
    if (path.indexOf("/cart") === 0) return "cart";
    if (path.indexOf("/checkouts/") === 0 || path.indexOf("/checkout") === 0) return "checkout";
    if (path === "/" || path === "") return "home";
    return "other";
  }

  function productHandle() {
    var path = window.location.pathname || "";
    var m = path.match(/\/products\/([^/?#]+)/);
    return m ? decodeURIComponent(m[1]) : null;
  }

  function productTitle() {
    try {
      var og = document.querySelector('meta[property="og:title"]');
      var t = og ? og.getAttribute("content") || "" : "";
      if (!t.trim()) {
        var el = document.querySelector("h1, .product__title, .product-title");
        t = el ? el.textContent || "" : "";
      }
      return t.replace(/\s+/g, " ").trim().slice(0, 200) || null;
    } catch (err) {
      return null;
    }
  }

  function priceCents() {
    try {
      var el = document.querySelector(
        ".price-item--regular, .price__current, [data-product-price], .price-item, [class*='price']"
      );
      if (!el) return null;
      var txt = (el.textContent || "").replace(/[^\d,.\-]/g, "").replace(",", ".");
      var n = parseFloat(txt);
      return isFinite(n) ? Math.round(n * 100) : null;
    } catch (err) {
      return null;
    }
  }

  function eventId(eventType) {
    return uuid("ev_" + eventType + "_");
  }

  function persistCartAttributes() {
    var sid = phSid();
    var attrs = attribution();
    var ck = cookies();
    var payload = { attributes: { _ps: sid } };
    if (ck.fbp) payload.attributes._fbp = ck.fbp;
    if (ck.fbc) payload.attributes._fbc = ck.fbc;
    ["utm_source", "utm_medium", "utm_campaign", "utm_content", "utm_term", "gclid"].forEach(function (k) {
      if (attrs[k]) payload.attributes[k] = attrs[k];
    });
    try {
      fetch("/cart/update.js", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
        keepalive: true,
      }).catch(function () {});
    } catch (err) {}
  }

  function collect(eventType, options) {
    options = options || {};
    var sid = phSid();
    var handle = options.product_handle || productHandle();
    var title = options.product_title || productTitle();
    var ev = {
      event_type: eventType,
      event_id: options.event_id || eventId(eventType),
      page_type: options.page_type || pageType(),
      page_url: window.location.pathname || "/",
      product_handle: handle,
      product_title: title,
      value_cents: options.value_cents != null ? options.value_cents : priceCents(),
    };
    var body = {
      pair_token: PAIR_TOKEN,
      session_id: sid,
      stage: options.stage || (pageType() === "cart" ? "cart" : pageType() === "product" ? "product" : "browsing"),
      current_page: pageType(),
      current_product: title || handle || "bravorn",
      event_source_url: window.location.href,
      events: [ev],
    };
    var attrs = attribution();
    Object.keys(attrs).forEach(function (key) {
      body[key] = attrs[key];
    });
    var ck = cookies();
    if (ck.fbp) body.fbp = ck.fbp;
    if (ck.fbc) body.fbc = ck.fbc;

    try {
      fetch(COLLECT_URL, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(body),
        keepalive: true,
        mode: "cors",
      }).catch(function () {});
    } catch (err) {}

    if (options.meta !== false) {
      try {
        initMetaPixel();
        var metaName = options.meta_name;
        if (!metaName && eventType === "page_view") metaName = "PageView";
        if (!metaName && eventType === "view_content") metaName = "ViewContent";
        if (!metaName && eventType === "add_to_cart") metaName = "AddToCart";
        if (!metaName && eventType === "initiate_checkout") metaName = "InitiateCheckout";
        if (metaName) {
          var payload = { currency: "EUR" };
          if (ev.product_handle) payload.content_ids = [ev.product_handle];
          if (ev.product_title) payload.content_name = ev.product_title;
          payload.content_type = "product";
          if (ev.value_cents) payload.value = Number(ev.value_cents) / 100;
          window.fbq("track", metaName, payload, { eventID: ev.event_id });
        }
      } catch (err2) {}
    }
    return ev.event_id;
  }

  initMetaPixel();
  phSid();
  attribution();

  collect("page_view", { stage: pageType() === "product" ? "product" : "browsing" });
  if (pageType() === "product") {
    collect("view_content", { stage: "product" });
  }

  persistCartAttributes();
  setTimeout(persistCartAttributes, 1500);

  var lastAtc = 0;
  function onAddToCart() {
    var now = Date.now();
    if (now - lastAtc < 800) return;
    lastAtc = now;
    collect("add_to_cart", { stage: "cart" });
    persistCartAttributes();
  }

  var _f = window.fetch;
  if (_f) {
    window.fetch = function () {
      try {
        var a = arguments[0];
        var u = a && a.url ? a.url : "" + a;
        if (u.indexOf("/cart/add") > -1) setTimeout(onAddToCart, 0);
      } catch (e) {}
      return _f.apply(this, arguments);
    };
  }
  try {
    var _xo = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function (m, u) {
      try {
        if (("" + u).indexOf("/cart/add") > -1) {
          this.addEventListener("load", function () {
            onAddToCart();
          });
        }
      } catch (e) {}
      return _xo.apply(this, arguments);
    };
  } catch (e) {}
  function looksLikeCheckout(el) {
    if (!el) return false;
    var href = "";
    var nm = "";
    var cls = "";
    var tx = "";
    try {
      href = (el.getAttribute && (el.getAttribute("href") || el.getAttribute("action"))) || el.action || "";
      href = String(href).toLowerCase();
      nm = ((el.getAttribute && el.getAttribute("name")) || el.name || "").toLowerCase();
      cls = ((el.getAttribute && el.getAttribute("class")) || el.className || "").toLowerCase();
      tx = ((el.textContent || "") + " " + ((el.getAttribute && el.getAttribute("aria-label")) || "")).toLowerCase();
    } catch (err) {}
    return (
      nm === "checkout" ||
      href.indexOf("/checkout") > -1 ||
      href.indexOf("/checkouts/") > -1 ||
      cls.indexOf("checkout") > -1 ||
      tx.indexOf("checkout") > -1 ||
      tx.indexOf("check out") > -1 ||
      tx.indexOf("commander") > -1 ||
      tx.indexOf("paiement") > -1 ||
      tx.indexOf("caisse") > -1 ||
      tx.indexOf("acheter") > -1
    );
  }

  var lastIc = 0;
  function onInitiateCheckout() {
    var now = Date.now();
    if (now - lastIc < 1200) return;
    lastIc = now;
    persistCartAttributes();
    collect("initiate_checkout", { stage: "checkout", meta_name: "InitiateCheckout" });
  }

  document.addEventListener(
    "submit",
    function (e) {
      var f = e.target;
      if (f && f.action && String(f.action).indexOf("/cart/add") > -1) onAddToCart();
      if (looksLikeCheckout(f) || looksLikeCheckout(document.activeElement)) onInitiateCheckout();
    },
    true
  );

  document.addEventListener(
    "click",
    function (e) {
      var t = e.target;
      if (!t) return;
      try {
        var a = t.closest && t.closest("a[href], button, [name='checkout'], [type='submit']");
        if (looksLikeCheckout(a) || looksLikeCheckout(t)) onInitiateCheckout();
      } catch (err) {}
    },
    true
  );
})();
